import React from "react";
import { BRAND } from "../lib/constants";
import ContactSection from "./ContactSection";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="footer" id="footer">
      <div className="container footer__inner">
        <div className="footer__left">
          <div className="footer__brand">
            <Logo />
          </div>
          <div className="footer__tagline">{BRAND.positioning}</div>
        </div>

        <div className="footer__right">
          <ContactSection />
        </div>
      </div>

      <div className="container footer__bottom">
        <span className="muted">
          © {new Date().getFullYear()} SmartUp360. All rights reserved.
        </span>
      </div>
    </footer>
  );
}
